// extracted by mini-css-extract-plugin
module.exports = {"container":"business-hub-footnotes_container__6D90p"};